<template>
    <div class="Partners">
        <div class="partenrs-header-container">
            <p class="partenrs-title-text">{{ titleText }}</p>
            <p class="partenrs-sub-title-text">{{ titleSubText }}</p>
        </div>
        <div class="partenrs-main-container">
            <el-row :gutter="30">
                <template v-for="item in partnerList">
                    <el-col :key="item.id" :span="6" class="partnerImgBox">
                        <el-image class="common-img" :src="item.imgUrl" ></el-image>
                    </el-col>
                </template>
                <!-- <el-col :span="6">
                    <img
                        class="common-img"
                        src="../../assets/images/huawei.png"
                        alt=""
                    />
                </el-col>
                <el-col :span="6">
                    <img
                        class="common-img"
                        src="../../assets/images/chinaMobile.png"
                        alt=""
                    />
                </el-col>
                <el-col :span="6">
                    <img
                        class="common-img"
                        src="../../assets/images/kuaishou.png"
                        alt=""
                    />
                </el-col>
                <el-col :span="6">
                    <img
                        class="common-img"
                        src="../../assets/images/jd.png"
                        alt=""
                    />
                </el-col>
                <el-col :span="6">
                    <img
                        class="common-img"
                        src="../../assets/images/huawei.png"
                        alt=""
                    />
                </el-col>
                <el-col :span="6">
                    <img
                        class="common-img"
                        src="../../assets/images/chinaMobile.png"
                        alt=""
                    />
                </el-col>
                <el-col :span="6">
                    <img
                        class="common-img"
                        src="../../assets/images/kuaishou.png"
                        alt=""
                    />
                </el-col>
                <el-col :span="6">
                    <img
                        class="common-img"
                        src="../../assets/images/jd.png"
                        alt=""
                    />
                </el-col> -->
            </el-row>
        </div>
    </div>
</template>

<script>
import { GETPICTUREINFO } from "../../utils/uriList";

export default {
    props: ["titleText", "titleSubText"],
    mounted() {
        this.getPartnerList();
    },
    data() {
        return {
            partnerList: [],
            type:1,
        };
    },
    methods: {
        async getPartnerList() {
            if(this.$route.path == "/"){
                this.type = 1;
            }else if(this.$route.path == "/successful-cases"){
                this.type = 2;
            }
            const response = await this.$http.get(GETPICTUREINFO, {
                params: {
                    type: this.type,
                },
            });
            if (response.data.code === 0) {
                this.partnerList = response.data.data;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/Home/Partners.scss";
</style>
